export const genders = [
  { id: 1, name: "Nam" },
  { id: 2, name: "Nữ" },
  { id: 3, name: "Tất cả" },
];

export const states = [
  { id: 1, name: "Có sẵn" },
  { id: 2, name: "Order" },
];
